/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 필터 버튼을 모아놓은 필터 바
 * 버전 : 1.0
 * 파일명 : FilterBarInterested.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-07-17
 * ================================================================ 

 *=================================================================
 */

import styled from 'styled-components'
import { Icon_ArrowDown } from '../common/CommonIcons'
import { useInterestedFilterStore } from 'src/stores/InterestedStore'
import DialogBirthday from './DialogBirthday'
import DialogLocation from './DialogLocation'
import DialogCouncelday from './DialogCouncelday'
import DialogEdu_Level from './DialogEdu_Level'
import DialogStatus from './DialogStatus'
import DialogGender from './DialogGender'

const PageWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;

  height: 33px;
  font-size: 14px;
  font-weight: 400;
`

const ElementWrapper = styled.div<{ $choice: boolean, $changed:boolean }>`
  display: flex;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 6px;

  border-radius: 100px;
  border: 1px solid   ${({ $choice, $changed }) => $choice || $changed ? '#229596' :'#ddd'};  
  color: ${({ $choice, $changed }) => $choice || $changed ? '#229596':'#000014'};
  background-color: ${({ $choice }) => $choice ? '#E5F4F8':'#fff'};
  font-weight: ${({ $choice, $changed }) => $choice ? '600': $changed ? '500':'400'};
  white-space: nowrap;
`

const FilterBarInterested = () => {
  const setField = useInterestedFilterStore((state) => state.setField);
  const elementValue = useInterestedFilterStore((state) => state.elementValue);
  const status = useInterestedFilterStore((state) => state.status);
  const edu_level = useInterestedFilterStore((state) => state.edu_level);
  const highschool_type = useInterestedFilterStore((state) => state.highschool_type);
  const gender = useInterestedFilterStore((state) => state.gender);
  const start_date = useInterestedFilterStore((state) => state.start_date);
  const end_date = useInterestedFilterStore((state) => state.end_date);
  const start_birth = useInterestedFilterStore((state) => state.start_birth);
  const end_birth = useInterestedFilterStore((state) => state.end_birth);


  const onClickLocation = ()=>{
    setField('element',<DialogLocation/>)
    setField('elementValue','Location')
    setField('isOpen',true)
  }

  const onClickStatus = ()=>{
    setField('element',<DialogStatus/>)
    setField('elementValue','Status')
    setField('isOpen',true)
  }

  const onClickCouncelday = ()=>{
    setField('element',<DialogCouncelday/>)
    setField('elementValue','Councel')
    setField('isOpen',true)
  }

  const onClickEdu_Level = ()=>{
    setField('element',<DialogEdu_Level/>)
    setField('elementValue','Edu')
    setField('isOpen',true)
  }

  const onClickBirthday = ()=>{
    setField('element',<DialogBirthday/>)
    setField('elementValue','Birth')
    setField('isOpen',true)
  }

  const onClickGender = ()=>{
    setField('element',<DialogGender/>)
    setField('elementValue','Gender')
    setField('isOpen',true)
  }


  const statusDefault = Array.isArray(status) && status.length === 1 && status[0] === 0;

  const counselstartDateDefault = start_date !== '' && start_date !== null;
  const counselstartendDateDefault = end_date !== '' && end_date !== null;
  const councelDate = counselstartDateDefault || counselstartendDateDefault;

  const isEduLevelDefault = Array.isArray(edu_level) && edu_level.length === 1 && edu_level[0] === 0;
  const isHighLevelDefault = Array.isArray(highschool_type) && highschool_type.length === 1 && highschool_type[0] === 0;
  const isChanged = !(isEduLevelDefault && isHighLevelDefault);

  const birthstartDateDefault = start_birth !== '' && start_birth !== null;
  const birthstartendDateDefault = end_birth !== '' && end_birth !== null;
  const birthDate = birthstartDateDefault || birthstartendDateDefault;

  const genderDefault = Array.isArray(gender) && gender.length === 1 && gender[0] === 0;

  return (
    <PageWrapper>
      <ElementWrapper onClick={onClickLocation} $choice={elementValue === 'Location'} $changed={true}>
        지역
        <Icon_ArrowDown style={{color:'#229596', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickStatus} $choice={elementValue === 'Status'} $changed={!statusDefault}>
        상태
        <Icon_ArrowDown style={{color: elementValue === 'Status' || !statusDefault ? '#229596' : '#969696', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickCouncelday} $choice={elementValue === 'Councel'} $changed={councelDate}>
        상담일
        <Icon_ArrowDown style={{color: elementValue === 'Councel' || councelDate ? '#229596' : '#969696', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickEdu_Level} $choice={elementValue === 'Edu'} $changed={isChanged}>
        학교 유형
        <Icon_ArrowDown style={{color: elementValue === 'Edu' || isChanged ? '#229596' : '#969696', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickBirthday} $choice={elementValue === 'Birth'} $changed={birthDate}>
        생년월일
        <Icon_ArrowDown style={{color: elementValue === 'Birth' || birthDate ? '#229596' : '#969696', fontSize:'16px'}}/>
      </ElementWrapper>
      <ElementWrapper onClick={onClickGender} $choice={elementValue === 'Gender'} $changed={!genderDefault}>
        성별
        <Icon_ArrowDown style={{color: elementValue === 'Gender' || !genderDefault ? '#229596' : '#969696', fontSize:'16px'}}/>
      </ElementWrapper>
    </PageWrapper>
  )
}

export default FilterBarInterested